import { Node } from 'Src/generated/graphql';

export type ProductPackage = {
  id: string;
  attributes: ProductPackageAttributes;
  groupings: ProductPackageGroupings;
  images: ProductPackageImages;
  isLooselyPackaged: boolean;
  marketPricings: ProductPackageMarketPricings;
  name: string;
  sku: string;
  variantPackagings: ProductPackageVariantPackagings;
};

type ProductPackageAttributes = Collection<ProductPackageAttribute>;
type ProductPackageAttribute = Node & {
  label: string;
  value: string;
  inturnType?: string;
};

type ProductPackageGroupings = Collection<ProductPackageGrouping>;
type ProductPackageGrouping = Node & {
  groupId: string;
  packageQuantity: number;
  packageQuantityInOffers: number;
  productUnits: number;
  sizeQuantities: ProductPackageGroupingSizeQuantities;
};

type ProductPackageGroupingSizeQuantities = Collection<ProductPackageGroupingSize>;
type ProductPackageGroupingSize = Node & {
  isMultiDimensional: boolean;
  name: string;
  productUnits: number;
  productUnitsInOffers: number;
};

type ProductPackageImages = Collection<ProductPackageImage>;
type ProductPackageImage = Node & {
  isForColorMatch: boolean;
  url: string;
};

type ProductPackageMarketPricings = Collection<ProductPackageMarketPricing>;
type ProductPackageMarketPricing = Node & {
  cost: Price;
  marketId: string;
  msrp: Price;
  wholesale: Price;
};

type ProductPackageVariantPackagings = Collection<ProductPackageVariantPackaging>;
type ProductPackageVariantPackaging = Node & {
  productId: string;
  variantUnitsPerPackage: number;
};

type Collection<Entity> = {
  nodes: Entity[];
};

export type Price = {
  displayValue: string;
  value: number | null;
};

export const EMPTY_PRODUCT_PACKAGE: ProductPackage = {
  attributes: {
    nodes: [],
  },
  groupings: {
    nodes: [],
  },
  id: 'EMPTY_PRODUCT_PACKAGE',
  images: {
    nodes: [],
  },
  isLooselyPackaged: true,
  marketPricings: {
    nodes: [],
  },
  name: 'Loading...',
  sku: '',
  variantPackagings: {
    nodes: [],
  },
};
